/**
 * Generate a conversation title with French timestamp format
 * Format: "Conversation DD/MM/YY HHhMM"
 * Example: "Conversation 02/10/25 14h30"
 */
export function generateTimestampTitle(date?: Date): string {
  const now = date || new Date();
  
  // Format date as DD/MM/YY
  const day = now.getDate().toString().padStart(2, '0');
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const year = now.getFullYear().toString().slice(-2);
  
  // Format time as HHhMM
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  
  return `Conversation ${day}/${month}/${year} ${hours}h${minutes}`;
}

